<template>
  <v-col class="pa-0 fill-height">
    <v-dialog v-model="generationDialog" persistent max-width="500px">
      <v-form ref="generateForm">
        <v-card>
          <v-card-title>
            <span>{{ $t("data-export-validation.title-generate") }}</span>
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="generationRequest.document_template"
              :items="templates"
              :label="$t('data-export-validation.template')"
              item-text="name"
              item-value="id"
              :rules="[rules.required, backEndValidation('document_template')]"
            ></v-select>
            <v-autocomplete
              v-model="generationRequest.destination_folder"
              :items="folders"
              item-text="name"
              item-value="id"
              :label="$t('data-export-validation.folder')"
              :rules="[rules.required, backEndValidation('destination_folder')]"
            ></v-autocomplete>
            <v-btn
              v-on:click="this.generateDocuments"
              class="ml-2 flex-shrink-0"
              color="primary"
              >{{ $t("data-export-validation.title-generate") }}</v-btn
            >
            <v-btn
              v-on:click="this.toggleGenerationDialog"
              class="ml-2 flex-shrink-0"
              color="secondary"
              >{{ $t("buttons.close") }}</v-btn
            >
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-toolbar dense flat>
      <v-toolbar-title>{{
        $t("data-export-validation.title")
      }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col v-if="validatorComponent && validatorContent" class="py-0 pb-12">
      <component
        :is="validatorComponent"
        :content="validatorContent"
        :feedback="validatorFeedback"
      ></component>
      <v-btn
        @click="startDownload"
        v-if="validatorComponent"
        class="primary mx-5"
        >{{ $t("buttons.download") }}</v-btn
      >
      <v-btn
        v-if="generationAvailable"
        @click="toggleGenerationDialog"
        class="primary mx-5"
        >{{ $t("data-export-validation.title-generate") }}</v-btn
      >
    </v-col>
    <v-row v-else>
      <v-progress-circular
        class="mx-auto mt-12"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-row>
  </v-col>
</template>

<script>
import { rules } from "../../../components/mixins/rules";
import { debounce } from "lodash";
import {
  TypeDetector,
  DmeFileTypes
} from "../../../plugins/DmeExport/TypeDetector";
import RemExportValidation from "../../../components/projects/accounting/data-export/validation-renderer/RemExportValidation";
import QualipoolExportValidation from "../../../components/projects/accounting/data-export/validation-renderer/QualipoolExportValidation";
import UnknownTypeValidation from "../../../components/projects/accounting/data-export/validation-renderer/UnknownTypeValidation";

export default {
  name: "DataExportValidation",
  mixins: [rules],
  components: {
    RemExportValidation,
    QualipoolExportValidation,
    UnknownTypeValidation
  },
  data() {
    return {
      validatorComponent: undefined,
      validatorContent: undefined,
      validatorFeedback: [],
      generationAvailable: false,
      generationDialog: false,
      generationRequest: {
        document_template: undefined,
        destination_folder: undefined
      }
    };
  },
  computed: {
    dme_file: {
      get() {
        return this.$store.getters[
          "projectAccountingStore/dmeFileStore/getItem"
        ];
      }
    },
    templates: {
      get() {
        return this.$store.getters["documentTemplateStore/getList"];
      }
    },
    folders: {
      get() {
        return this.$store.getters["folderStore/getList"];
      }
    }
  },
  watch: {
    dme_file: {
      handler: debounce(function() {
        this.updateValidator();
      }, 1000),
      deep: true
    }
  },
  methods: {
    fetchDmeFile() {
      if (this.$route.params.id) {
        this.$store.dispatch("projectAccountingStore/dmeFileStore/get", {
          id: this.$route.params.id,
          project_id: "-"
        });
      }
    },
    startDownload() {
      return this.$store.dispatch(
        "projectAccountingStore/dmeFileStore/download",
        {
          params: {
            project_id: this.$route.params.project_id,
            id: this.$route.params.id
          }
        }
      );
    },
    toggleGenerationDialog() {
      this.getTemplates();
      this.getFolders();
      this.generationDialog = !this.generationDialog;
    },
    generateDocuments() {
      if (!this.$refs.generateForm.validate()) {
        return;
      }

      this.generationDialog = false;
      this.$store.dispatch("projectAccountingStore/dmeFileStore/generate", {
        params: {
          project_id: this.$route.params.project_id,
          id: this.$route.params.id,
          ...this.generationRequest
        }
      });
    },
    updateValidator() {
      const detector = new TypeDetector(this.dme_file.response);

      const validatorComponentName = {
        [DmeFileTypes.REM_DTA_V1]: "RemExportValidation",
        [DmeFileTypes.QUALIPOOL_DtaVka_V1]: "QualipoolExportValidation"
      };

      this.validatorFeedback = this.dme_file.feedback;
      this.validatorContent = detector.getParsed() ?? "-";
      this.validatorComponent =
        validatorComponentName[detector.getType()] ?? "UnknownTypeValidation";
      this.generationAvailable = detector.getType() === DmeFileTypes.REM_DTA_V1;
    },
    getTemplates() {
      this.$store.dispatch("documentTemplateStore/getList", {
        params: {
          filters: {
            document_type: "proportions-bill"
          }
        }
      });
    },
    getFolders() {
      this.$store.dispatch("folderStore/getList", {
        params: { limit: -1 }
      });
    }
  },
  mounted() {
    this.fetchDmeFile();
  }
};
</script>

<style scoped></style>
